export default "__VITE_ASSET__BuNW7YdM__"